import { takeEvery, fork, put, all, call, takeLatest } from "redux-saga/effects";

// Login Redux States
import { SettingsActionTypes } from "./types";
import {
  settingsApiResponseSuccess,
  settingsApiResponseError,
} from "./actions";

import {
  getSettings as getSettingsApi,
  updateSettings as updateSettingsApi,
  loadThirdApiUrl as loadThirdApiUrlApi,
  ucLoadUserConfig as ucLoadUserConfigApi,
} from "../../api/index";
import { ThirdApi } from "api/apiThird";

function* getSettings() {
  try {
    const response: Promise<any> = yield call(getSettingsApi);
    yield put(
      settingsApiResponseSuccess(
        SettingsActionTypes.GET_USER_SETTINGS,
        response
      )
    );
  } catch (error: any) {
    yield put(
      settingsApiResponseError(SettingsActionTypes.GET_USER_SETTINGS, error)
    );
  }
}

function* ucLoadUserConfig() {
  try {
    const response: Promise<any> = yield call(ucLoadUserConfigApi);
    // console.log('ucLoadUserConfig:', response);
    yield put(settingsApiResponseSuccess(SettingsActionTypes.UC_LOAD_USER_CONFIG,response));
  } catch (error: any) {
    yield put(settingsApiResponseError(SettingsActionTypes.UC_LOAD_USER_CONFIG, error));
  }
}

function* loadThirdApiUrl() {
  try {
    const response: Promise<any> = yield call(loadThirdApiUrlApi);
    ThirdApi.setApiUrl(response);
    // yield put(settingsApiResponseSuccess(SettingsActionTypes.GET_USER_SETTINGS,response));
  } catch (error: any) {
    // yield put(settingsApiResponseError(SettingsActionTypes.GET_USER_SETTINGS, error));
  }
}


function* updateSettings({ payload: { field, value } }: any) {
  try {
    const response: Promise<any> = yield call(updateSettingsApi, field, value);
    yield put(
      settingsApiResponseSuccess(
        SettingsActionTypes.UPDATE_USER_SETTINGS,
        response
      )
    );
  } catch (error: any) {
    yield put(
      settingsApiResponseError(SettingsActionTypes.UPDATE_USER_SETTINGS, error)
    );
  }
}

export function* watchGetSettings() {
  yield takeEvery(SettingsActionTypes.GET_USER_SETTINGS, getSettings);
}
export function* watchUcLoadUserConfig() {
  yield takeEvery(SettingsActionTypes.UC_LOAD_USER_CONFIG, ucLoadUserConfig);
}
export function* watchUpdateSettings() {
  yield takeEvery(SettingsActionTypes.UPDATE_USER_SETTINGS, updateSettings);
}

export function* watchLoadThirdApiUrl() {
  yield takeLatest(SettingsActionTypes.LOAD_THIRD_API_URL, loadThirdApiUrl);
}


function* settingsSaga() {
  yield all([
    fork(watchGetSettings),
    fork(watchUcLoadUserConfig),
    fork(watchUpdateSettings),
    fork(watchLoadThirdApiUrl)
  ]);
}

export default settingsSaga;
